import React from "react";
import { Button, Popup, Icon } from "semantic-ui-react";

const ActionsMenu = (props: { disabled: boolean; actions: React.ReactElement[] }) => {
  const { disabled, actions } = props;

  return (
    <Popup
      basic
      style={{ padding: 0, zIndex: 9 }}
      position="right center"
      on="click"
      trigger={
        <Button
          aria-label="Action button"
          disabled={disabled}
          floated="right"
          size={"mini"}
          style={{ padding: "4px" }}
          color={"blue"}
        >
          <Icon name="ellipsis horizontal" style={{ margin: "auto" }} />
        </Button>
      }
    >
      <Button.Group basic vertical>
        {actions}
      </Button.Group>
    </Popup>
  );
};

export default ActionsMenu;
